import { UserSetting } from '../../components/UserSettings/userSettings';

function UserSettings() {
  return (
    <div>
      <UserSetting></UserSetting>
    </div>
  );
}

export default UserSettings;